var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarOut = function SvgCalendarOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "#DEDEDE",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.657 0a.857.857 0 0 0-.857.857v.972H7.2V.857a.857.857 0 1 0-1.714 0v.972h-.972A4.514 4.514 0 0 0 0 6.343v9.143A4.514 4.514 0 0 0 4.514 20h10.972A4.514 4.514 0 0 0 20 15.486a.486.486 0 0 0-.486-.486h-.743a.486.486 0 0 0-.485.486 2.8 2.8 0 0 1-2.8 2.8H4.514a2.8 2.8 0 0 1-2.8-2.8V9.029h16.572V9.5a.5.5 0 0 0 .5.5h.714a.5.5 0 0 0 .5-.5V6.343a4.514 4.514 0 0 0-4.514-4.514h-.972V.857A.857.857 0 0 0 13.657 0M1.714 6.343v.971h16.572v-.971a2.8 2.8 0 0 0-2.8-2.8h-.972v.971a.857.857 0 0 1-1.714 0v-.971H7.2v.971a.857.857 0 1 1-1.714 0v-.971h-.972a2.8 2.8 0 0 0-2.8 2.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.75a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.03 10.53a.75.75 0 0 1 1.061 0l1.768 1.768a.75.75 0 0 1-1.06 1.06l-1.769-1.767a.75.75 0 0 1 0-1.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.859 12.298a.75.75 0 0 1 0 1.06l-1.768 1.768a.75.75 0 0 1-1.06-1.06l1.767-1.768a.75.75 0 0 1 1.06 0"
  })));
};
export default SvgCalendarOut;